import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from '@sainsburys-tech/boltui-utils'
import { Button, Drawer, Slider, Image } from '@sainsburys-tech/bolt'
import * as Styled from './ugc.styles'

const UGCQuickViewStorystream = (props) => {
  const { displayImage, toggleCallback } = props

  const renderSlides = () => {
    const slides = []

    if (displayImage?.urlLarge) {
      slides.push(<Image data-test='displayImage' src={displayImage?.urlLarge} alt='' />)
    }

    if (!isEmpty(displayImage?.secondaryImages)) {
      displayImage.secondaryImages.map((image, index) =>
        slides.push(<Image data-test={`secondaryImage-${index}`} src={image} alt='' key={`image-${index}`} />)
      )
    }

    return slides
  }

  const slideProps = {
    itemsPerSlideXs: 1,
    itemsPerSlideSm: 1,
    itemsPerSlideMd: 1,
    itemsPerSlideLg: 1,
    isInfiniteCycle: true,
    showChevrons: true
  }

  const heading =
    !displayImage?.author && !displayImage?.socialMediaUrl ? (
      ''
    ) : (
      <Styled.HeadingContainer>
        {displayImage?.author && <span>{`Shared by @${displayImage.author}`}</span>}
        {displayImage?.socialMediaUrl && (
          <Styled.InstagramIconLink data-test='instagram-icon-link' href={displayImage.socialMediaUrl} target='_blank'>
            <Styled.InstagramIcon data-test='instagram-icon' />
          </Styled.InstagramIconLink>
        )}
      </Styled.HeadingContainer>
    )

  return (
    <Drawer heading={heading} show={!isEmpty(displayImage)} padding={false} onClose={toggleCallback}>
      <Styled.QuickviewImage>
        <Slider {...slideProps} items={renderSlides()} />
      </Styled.QuickviewImage>
      <Styled.DescriptionContainer>
        {displayImage?.description && <p>{displayImage.description}</p>}
        {!isEmpty(displayImage?.nonPDPs) && displayImage?.buttonText && (
          <Button full as='a' href={displayImage.nonPDPs[0]}>
            {displayImage.buttonText}
          </Button>
        )}
      </Styled.DescriptionContainer>
    </Drawer>
  )
}

UGCQuickViewStorystream.displayName = 'UGCQuickViewStorystream'

UGCQuickViewStorystream.propTypes = {
  displayImage: PropTypes.object,
  toggleCallback: PropTypes.func
}

UGCQuickViewStorystream.defaultProps = {
  displayImage: {}
}

export default UGCQuickViewStorystream
